<template>
  <div class="col-lg-8">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title">Activity</h5>
      </div>
      <div class="card-body card-body-height">
        <div
          v-if="notifications === []"
          class="d-flex h-100 align-center justify-center"
        >
          <p>No activity at the moment</p>
        </div>
        <ul v-else class="activity-feed">
          <li
            v-for="message in notifications"
            :key="message.id"
            class="feed-item"
          >
            <div class="feed-date">
              {{ formatToMonthandYear(message.created_at) }}
              {{ formattedTime(message.created_at) }}
            </div>
            <span class="feed-text"> {{ message.title }} </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { computed } from "vue";
import { formatToMonthandYear, formattedTime } from "@/assets/composables/date";

const store = useStore();

const notifications = computed(() => {
  return store.getters["auth/profile_notifications"];
});
</script>
